module.exports = __webpack_public_path__ + "img/top2.08e38046.png";